import fetch from '@/plugin/axios'

// 查询列表
export function getList (query) {
  return fetch({
    url: '/api/order/clock-in-log/list',
    method: 'Post',
    data: query
  })
}
export function getClockInLog (id) {
  return fetch({
    url: `/api/order/clock-in-log/info/${id}`,
    method: 'Get'
  })
}
// 审核通过
export function getPass (query) {
  return fetch({
    url: '/api/order/clock-in-log/audit/pass',
    method: 'Post',
    data: query
  })
}

// 审核拒绝
export function getReject (query) {
  return fetch({
    url: '/api/order/clock-in-log/audit/reject',
    method: 'Post',
    data: query
  })
}

// 复审核通过
export function getPafss (query) {
  return fetch({
    url: '/api/order/clock-in-log/review',
    method: 'Post',
    data: query
  })
}

// 复审核未通过
export function getResject (query) {
  return fetch({
    url: '/api/order/clock-in-log/review',
    method: 'Post',
    data: query
  })
}

export function addToResource (logId, data) {
  return fetch({
    url: '/api/order/clock-in-log/add_source/' + logId,
    method: 'Post',
    data: data
  })
}
